import { configureStore } from "@reduxjs/toolkit";
import { AnyAction, combineReducers } from "redux";

import { authReducer } from "Auth/state";
import { dataReducer } from "Venues/state";
import { dataReducer as bandDataReducer } from "Bands/state";
import { toastReducer } from "shared/components/Toast";
import { messageReducer } from "shared/components/MessageModal";
import { unitReducer } from "shared/components/UnitConverter";
import { IStoreState } from "App/types";
import { AUTH_ACTIONS } from "Auth/types";

const reducer = combineReducers({
  auth: authReducer,
  data: dataReducer,
  bandData: bandDataReducer,
  toasts: toastReducer,
  message: messageReducer,
  units: unitReducer,
});

const rootReducer = (state: IStoreState | undefined, action: AnyAction) => {
  // clear state after logout
  if (action.type.startsWith(AUTH_ACTIONS.logout)) {
    return reducer(undefined, action);
  }

  return reducer(state, action);
};

const store = configureStore({ reducer: rootReducer });

export { store };
